import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { teamsMng } from '../api/teamsMng';
import TeamForm from './TeamForm';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function AddTeamDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onAdd = () => {} } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  const createTeam = async () => {
    setLoading(true);
    const team = { ...formData };
    delete team.isValid;
    try {
      await teamsMng.addTeam(team);
      onAdd();
      _onClose();
      toast.success('Team added successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Add Team
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <TeamForm
          onChange={(data) => {
            console.log('on change');
            console.log(data);
            setFormData({ ...data });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Add Team</span>}
            onClick={createTeam}
            onEnter={createTeam}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddTeamDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

AddTeamDialog.defaultProps = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: () => {},
};

export default AddTeamDialog;
